import { render, staticRenderFns } from "./cModalExpense.vue?vue&type=template&id=495eb848&scoped=true"
import script from "./cModalExpense.vue?vue&type=script&lang=js"
export * from "./cModalExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495eb848",
  null
  
)

export default component.exports